import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserInfoContext, breadConstent } from '@/store/userInfo'
import { open } from '@/utils/common'
import styles from '../style.module.less'

const Bread = () => {
  const {breads, setBreasds} = useUserInfoContext()
  const location = useLocation()
  const navigator = useNavigate()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    setBreasds([])
  }, [location.pathname, setBreasds])
  
  useEffect(() => {
    const core = () => {
      setVisible(document.documentElement.scrollTop < 200)
    }
    window.addEventListener('scroll', core)
    return () => {
      window.removeEventListener('scroll', core)
    }
  }, [])

  const handleClick = useCallback((bread) => {
    let pathname = ''
    switch(bread.type) {
      case breadConstent.CATEGORY:
        pathname = '/category/' + bread.id
        break
      case breadConstent.PRODUCT:
        pathname = '/product/' + bread.id
        break
      case breadConstent.DETAIL:
        navigator('/product/detail/' + bread.id)
        return
      default:
        pathname = bread.type.startsWith('/') ? bread.type : '/'
        break
    }
    navigator(pathname)
  }, [navigator])

  return visible && (
    <div className={styles['bread']}>
      {
        breads.map((bread, index) => (
          <div className={styles['bread-item']} key={bread.title}>
            <span className={index === breads.length - 1 ? styles.active : ''} onClick={() => handleClick(bread)}>{bread.title}</span>
          </div>
        ))
      }
    </div>
  )
}

export default Bread
